export abstract class TellentComponentsNotificationService {
  public abstract success(title: string, message?: string): void;
  public abstract error(title: string, message?: string): void;
}
